import { AllowanceLegacyModel } from "@/features/allowance/types/allowanceLegacyModel";
import { AllowanceBaseModel } from "@/features/allowance/types/allowanceModels";

export const legacyAllowanceModelToNewModel = (
  items: AllowanceLegacyModel[]
): AllowanceBaseModel[] => {
  return items.map((item) => legacyAllowanceItemToNewItem(item));
};

export const legacyAllowanceItemToNewItem = (
  item: AllowanceLegacyModel
): AllowanceBaseModel => {
  const allowanceBaseModel: AllowanceBaseModel = {
    wbsEntryId: item.deliverableId,
    id: item.id,
    name: item.name,
    description: item.description,
    cost: item.cost,
    duration: item.duration,
    emissions: item.emissions,
  };
  return allowanceBaseModel;
};

export const newAllowanceModelToLegacyModel = (
  allowance: AllowanceBaseModel
): AllowanceLegacyModel => {
  const allowanceLegacyBaseModel: AllowanceLegacyModel = {
    deliverableId: allowance.wbsEntryId,
    id: allowance.id,
    name: allowance.name,
    description: allowance.description,
    cost: allowance.cost,
    duration: allowance.duration,
    emissions: allowance.emissions,
  };
  return allowanceLegacyBaseModel;
};
